import React from 'react';
import { SFEntityID } from 'utils/types';
import PropTypes from 'prop-types';
import css from './HoursSection.scss';
import Title from '../../common/Title';
import { some } from 'lodash';
import { getWord } from 'utils/tenant';

const  HourItem = ({title, hoursText, walkInsOnly}) => {
  return (
    <div className={css['hours-item']}>
      <span className={css['hours-title']}>{title}:</span>
      {window.innerWidth <= 760 ? <br/> : " "}
      {hoursText}
      {walkInsOnly ? ' *' : ''}
    </div>
  );
}

export default class HoursSection extends React.Component {

  render() {
    return (
      <div className={css['hours-container']}>
        <Title text={`This Week's ${getWord('officeHours')}`} />
        {this.props.officeHours.map((hour, i) => <HourItem key={i} {...hour} />)}
        {!some(this.props.officeHours, 'walkInsOnly') ? '' : <i>* {getWord('dropIns')} only</i>}
      </div>
    );
  }
}

HoursSection.propTypes = {
  personId: SFEntityID.isRequired,
  officeHours: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    hoursText: PropTypes.string.isRequired,
    walkInsOnly: PropTypes.bool.isRequired
  }))
};

HourItem.propTypes = {
  title: PropTypes.string.isRequired,
  hoursText: PropTypes.string.isRequired,
  walkInsOnly: PropTypes.bool.isRequired
};
